import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import AutoQuery from 'servicestack/auto-query/auto-query'
import $session from 'servicestack/session'

class ContactPromptController {
  constructor($rootScope, $uibModalInstance, options) {
    var $ctrl = this;
    basicController($ctrl);
    var model = $ctrl.model = options.model;
    var bus = $ctrl.bus = new ServiceBus($rootScope);
    $ctrl.$uibModalInstance = $uibModalInstance;
    if (!$ctrl.model.contact) {
      var date = new Date();
      $ctrl.model.contact = {
        retailerId: $ctrl.model.customer.id,
        createdBy: $session.userAuthName,
        username: $session.userAuthName
      };
    }

    if ($ctrl.model.contact.retailerId) {
      var retailerQuery = new AutoQuery({
        url: 'QueryRetailers.json?Id=' + $ctrl.model.contact.retailerId,
        orderBy: 'CompanyName',
        autoLoad: true,
        onLoaded: args => { $ctrl.model.customer = args.first; }
      });
    }

    $ctrl.title = options.title || 'Contact';
    $ctrl.save = $ctrl.submit = function () {
      if ($ctrl.model.contact.id) {
        bus.send('UpdateContact.json', $ctrl.model.contact).then(function (response) {
          $rootScope.$emit('contactSaved', $ctrl.model);
          $uibModalInstance.close($ctrl.model);
        });
      } else {
        bus.send('CreateContact.json', $ctrl.model.contact).then(function (response) {
          $rootScope.$emit('contactSaved', $ctrl.model);
          $uibModalInstance.close($ctrl.model);
        });
      }
    };
    $ctrl.delete = function () {
      //$uibModalInstance.close($ctrl.model);
      return modals.confirm("Are you sure?", "Delete Contact").result.then(function () {
        $ctrl.bus.send('DeleteContact.json', $ctrl.model.contact).then(function (response) {
          $rootScope.$emit('contactDeleted', $ctrl);
          console.info("Close it");
          $ctrl.$uibModalInstance.close($ctrl.model);
          $ctrl.$uibModalInstance.dismiss("");
        });
      });
    };
  }
  dismiss(reason) {
    let $ctrl = this;
    //$ctrl.$dismiss();
    //$ctrl.$close();
    $ctrl.$uibModalInstance.close();
    $ctrl.$uibModalInstance.dismiss(reason);
  }
}

export default ContactPromptController;